import React from 'react';
import {
	CardContainer,
	TagContainer,
	ImageContainer,
	DescriptionContainer,
	StyledTag,
	TitleContainer,
	CardTitle,
	ImageOffContainer,
	ImageOff,
	DiscountContainer,
	DiscountText
} from './styles';
import { Button } from '../../Buttons';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import LabelTitle from '../../Titles/LabelTitle';
import Money from './Money';
import Link from '../../Link';

const PriceCard = ({
	tag,
	tagColor,
	label,
	title,
	disabled,
	price,
	information,
	image,
	imageOff,
	labelWhite = false,
	discount
}) => {
	const { t, i18n } = useTranslation();

	const getInformation = (information, className) => {
		return information.map((data, idx) => (
			<Typography paragraph key={idx} className={className}>
				{t(data)}
			</Typography>
		));
	};

	return (
		<CardContainer>
			{imageOff && (
				<ImageOffContainer>
					<ImageOff src={imageOff} />
				</ImageOffContainer>
			)}
			<ImageContainer image={image}>
				<TagContainer>
					<StyledTag
						label={tag}
						tagColor={tagColor}
						color={labelWhite ? '#fff' : '#2a2929'}
					/>
				</TagContainer>
				<LabelTitle content={label} color={image ? '#FFF' : null} />
			</ImageContainer>

			<DescriptionContainer>
				<TitleContainer>
					<CardTitle color={'textSecondary'} variant={'h3'}>
						{title}
					</CardTitle>
				</TitleContainer>

				<Money
					value={t(price.value)}
					lastValue={t(price.lastValue)}
					description={t(price.description)}
					promotion={t(price.promotion)}
				/>

				{getInformation(information.primary, 'info-primary')}
				<Link href={`/cursos/${i18n.language}/users/sign_up`}>
					<Button
						color={'primary'}
						variant={'contained'}
						content={t('general.actions.registerMe')}
					/>
				</Link>
				{discount && (
					<DiscountContainer>
						<DiscountText color={'textSecondary'} variant={'h5'}>
							{t(discount.text)}
						</DiscountText>
						<Link href={t(discount[`link${i18n.language.toUpperCase()}`])}>
							<Button
								color="primary"
								variant={'contained'}
								content={t(discount.button)}
							/>
						</Link>
					</DiscountContainer>
				)}
			</DescriptionContainer>
		</CardContainer>
	);
};

export default PriceCard;
